/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of engine step (so we can emit proper model typing for pydantic).
 *
 * These are also used to conditionally render the progress section on the PRD.
 * Ensure that each choice here is handled by `$addProgressSection`.
 */
export var EngineStepType;
(function (EngineStepType) {
    EngineStepType["QUEUEING_JOB"] = "queueing_job";
    EngineStepType["AWAITING_PLANNER"] = "awaiting_planner";
    EngineStepType["PLAN_START"] = "plan_start";
    EngineStepType["PLAN_ITERATION"] = "plan_iteration";
    EngineStepType["PRD_ITERATION"] = "prd_iteration";
    EngineStepType["PLAN_RESULTS"] = "plan_results";
    EngineStepType["BUILD_SOLUTION"] = "build_solution";
    EngineStepType["ASK_QUESTIONS"] = "ask_questions";
})(EngineStepType || (EngineStepType = {}));
